module.exports = __webpack_public_path__ + "img/avatar-9.18344f9e.jpg";